export default __webpack_public_path__ + "static/media/CheckCircle.da9bfa19.svg";